// extracted by mini-css-extract-plugin
export default {"button":"WhatsAppButton_button__a3YFc"};